import {
  ERR_AGENT_STATUS_API_REQ,
  ERR_DEVICESECRET_API_REQ,
  ERR_DEV_API_REQ,
  ERR_DEV_POWER_ON,
  ERR_DEV_POWER_RESTART,
  ERR_DEV_POWER_STOP,
  ERR_DEV_STATUS_NOT_FOUND,
  ERR_GET_CLIENT_CONFIG_API_REQ,
  ERR_GET_DEVICE_API_REQ,
  ERR_GET_DEV_ID,
  ERR_GET_PUBLIC_KEY_API_REQ,
  // ERR_GET_WAN_IP_API_REQ,
  ERR_GET_TOKEN_API_REQ,
  ERR_IMGCODE_API_REQ,
  ERR_LOGIN_API_REQ,
  ERR_NO_DEVICE,
  ERR_NO_KC_DEVICE,
  ERR_SET_KC_PASSWORD_API_REQ,
  // [日志上传功能已注释] ERR_UPLOAD_LOG_API_REQ,
  ERR_WALLPAPER_API_REQ,
} from "@/models/constants"
// [日志上传功能已注释] import http, { httpNoAuth } from "@/utils/request"
import http from "@/utils/request"
import {
  APIResponse,
  ClientConfigRawResp,
  ClientConfigResult,
  DeviceInfoRes,
  DeviceStateRes,
  HttpAPIError,
  HttpReqError,
  ImgCodeRes,
  LoginRes,
  OldDeviceInfoRes,
  WallpaperListRes,
} from "./model"
import { getAppConfig, getAppVersion } from "@/config/env"
import { Ok } from "@/models/biz_model"

export interface CaptchaVerifyRes {
  verified: boolean
}

export interface VerificationSendReq {
  captchaId: string
  captcha: string
  phone?: string
  email?: string
  type?: "trusted_device" | "data_security_lock" | "login_2fa" | string
}

export interface VerificationSendRes {
  token: string
}

export interface LoginDeviceRes {
  deviceID: string
  deviceName: string
  os: string
  deviceType: number
  clientVersion: string
  ip: string
  province: string
  isp: string
  loginAt: string
  trusted: boolean
  trustedAt: string
  currentDevice: boolean
}

export interface TrustedDeviceRes {
  deviceID: string
  trusted: boolean
  trustedAt: string
}

export interface PrivacyConfigItem<T> {
  value: T
  managed: boolean
  editable: boolean
}

export interface PrivacyConfigRes {
  auto_lock_minutes: PrivacyConfigItem<number>
  login_device_scope: PrivacyConfigItem<number>
  face_login_enabled: PrivacyConfigItem<boolean>
  auto_login_disable?: PrivacyConfigItem<boolean>
  two_factor_enabled: PrivacyConfigItem<boolean>
  data_security_lock_enabled: PrivacyConfigItem<boolean>
}

export interface DeviceSecretRes {
  deviceSecret: string
}

export interface PrivacyConfigUpdateReq {
  auto_lock_minutes?: number
  login_device_scope?: number
  face_login_enabled?: boolean
  two_factor_enabled?: boolean
  data_security_lock_enabled?: boolean
}

// 获取本地设备ID接口
async function getDeviceID(): Promise<APIResponse<number>> {
  try {
    const resp = await http.get("/v1/getID", { withCredentials: false })
    return resp.data
  } catch (e: any) {
    return parseReqError(e, ERR_GET_DEV_ID)
  }
}

// 获取多台设备状态接口
// ids: 设备 desktopId 列表，不传则返回空
async function getDeviceStatus(
  ids: string[]
): Promise<APIResponse<DeviceStateRes[]>> {
  try {
    const resp = await http.post("/v2/tenant/vps/states", { ids })
    const status = resp.data.list
    if (ids.length > 0 && status.length === 0) {
      return new HttpAPIError(ERR_DEV_STATUS_NOT_FOUND, "设备状态列表为空")
    }
    return status
  } catch (e: any) {
    return parseReqError(e, ERR_DEV_API_REQ)
  }
}

/*
// 获取出口公网 IP（暂不启用）
async function getWanIp(): Promise<APIResponse<string>> {
  try {
    const resp = await http.get("/instance/wanip", { withCredentials: false })
    if (resp.data && typeof resp.data === "object" && resp.data.wanip != null) {
      return String(resp.data.wanip)
    }
    return String(resp.data)
  } catch (e: any) {
    return parseReqError(e, ERR_GET_WAN_IP_API_REQ)
  }
}
*/

// 查询agent在线状态接口
async function getAgentStatus(deviceId: number): Promise<APIResponse<string>> {
  try {
    const AgentStatusUrl = getAppConfig().signalingUrl
    // 获取agent在线状态
    const resp = await http.get(`${AgentStatusUrl}/peerStatus/${deviceId}`, {
      withCredentials: false,
    })
    const status = resp.data.Online

    return status // "offline" "online"
  } catch (e: any) {
    return parseReqError(e, ERR_AGENT_STATUS_API_REQ)
  }
}

// 设备列表（旧的，用来获取上报数据的region/business_scene，后面这个字段会在 新登录接口中拿）
async function getDeviceListOld(): Promise<APIResponse<OldDeviceInfoRes[]>> {
  try {
    // 获取设备列表
    const resp = await http.get("/device/getDeviceList", {
      withCredentials: false,
    })

    const devices = resp.data.list as OldDeviceInfoRes[]
    if (devices.length === 0) {
      return new HttpAPIError(ERR_NO_KC_DEVICE, "企业 设备列表为空")
    }

    return devices
  } catch (e: any) {
    return parseReqError(e, ERR_GET_DEVICE_API_REQ)
  }
}

// 设备列表（新的）
async function getDeviceList(): Promise<APIResponse<DeviceInfoRes[]>> {
  try {
    // 获取设备列表
    const resp = await http.get("/v2/device/getDeviceList", {
      withCredentials: false,
    })

    const devices = resp.data as DeviceInfoRes[]
    if (devices.length === 0) {
      return new HttpAPIError(ERR_NO_KC_DEVICE, "企业 设备列表为空")
    }

    return devices
  } catch (e: any) {
    return parseReqError(e, ERR_GET_DEVICE_API_REQ)
  }
}

// 获取连接设备token
async function getDeviceConnToken(
  myDeviceId: number,
  oppDeviceId: number
): Promise<APIResponse<string>> {
  try {
    const resp = await http.post("/client/getToken", {
      myDeviceId,
      oppDeviceId,
    })
    return resp.data.token
  } catch (e: any) {
    return parseReqError(e, ERR_GET_TOKEN_API_REQ)
  }
}

let errCode: number
// 控制设备开关机接口
async function deviceControl(
  action: string,
  desktopID: string
): Promise<APIResponse<any>> {
  const path = "/v2/tenant/vps/control"
  try {
    const resp = await http.post(path, { action, desktopID })
    return resp.data
  } catch (e) {
    // 此接口是其他部门开发，请求错误时会将 http status (例如：400) 作为业务错误码返回，需要转换为 http 请求错误
    let err = e

    if (err instanceof HttpAPIError) {
      err = new HttpReqError(path, err.code)
    }

    if (action === "start") {
      errCode = ERR_DEV_POWER_ON
    } else if (action === "stop") {
      errCode = ERR_DEV_POWER_STOP
    } else if (action === "resume") {
      errCode = ERR_DEV_POWER_RESTART
    }
    return parseReqError(err, errCode)
  }
}

// 获取图片验证码
async function getImgCodeApi(): Promise<APIResponse<ImgCodeRes>> {
  const path = "/base/imgCode"
  try {
    const resp = await http.post(path)
    return resp.data
  } catch (e) {
    return parseReqError(e, ERR_IMGCODE_API_REQ)
  }
}

// 原登录接口（用来在云电脑重启/关机时 校验登录密码）
async function oldLogin(
  username: string,
  password: string,
  // fingerprintId: string, // 浏览器指纹
  captcha?: string,
  captchaId?: string,
  ksAuthCode?: string, // 登录token,会校验有效期
  phone?: string,
  smsCode?: string,
  smsToken?: string
): Promise<APIResponse<LoginRes>> {
  try {
    const resp = await http.post("/tenant/login", {
      username,
      password,
      // fingerprintId,
      captcha,
      captchaId,
      ksAuthCode,
      phone,
      smsCode,
      smsToken,
    })

    return resp.data
  } catch (e: any) {
    return parseReqError(e, ERR_LOGIN_API_REQ)
  }
}
// 新登录接口
async function newLogin(
  username: string,
  password: string,
  captcha?: string,
  captchaId?: string,
  ksAuthCode?: string, // 登录token,会校验有效期
  phone?: string,
  smsCode?: string,
  smsToken?: string,
  fpHash?: string // 浏览器指纹
): Promise<APIResponse<LoginRes>> {
  try {
    const resp = await http.post(
      "/v2/tenant/login",
      {
        username,
        password,
        captcha,
        captchaId,
        ksAuthCode,
        phone,
        smsCode,
        smsToken,
        deviceID: fpHash,
      },
      {
        headers: {
          "X-Client-Type": 2,
          "X-Client-Version": getAppVersion(),
        },
      }
    )
    if (resp.data.list.length === 0) {
      return new HttpAPIError(ERR_NO_DEVICE, "设备列表为空")
    }

    return resp.data
  } catch (e: any) {
    return parseReqError(e, ERR_LOGIN_API_REQ)
  }
}

/** 使用当前浏览器绑定的 deviceSecret 进行免密码登录。 */
async function deviceSecretLogin(
  username: string,
  token: string,
  deviceSecret: string,
  fpHash: string,
  phone?: string,
  smsCode?: string,
  smsToken?: string
): Promise<APIResponse<LoginRes>> {
  try {
    const resp = await http.post(
      "/v2/tenant/login",
      {
        username,
        token,
        deviceSecret,
        s26GSMNdZ: true,
        Cda1GVso: true,
        captcha: "",
        captchaId: "",
        deviceID: fpHash,
        deviceId: fpHash,
        phone,
        smsCode,
        smsToken,
      },
      { headers: { "X-Client-Type": 2, "X-Client-Version": getAppVersion() } }
    )
    return resp.data
  } catch (e: any) {
    return parseReqError(e, ERR_LOGIN_API_REQ)
  }
}

async function createDeviceSecret(
  deviceID: string,
  authType: number
): Promise<APIResponse<DeviceSecretRes>> {
  try {
    const resp = await http.post("/tenant/deviceSecret", { deviceID, authType })
    return resp.data
  } catch (e: any) {
    return parseReqError(e, ERR_DEVICESECRET_API_REQ)
  }
}

// 企业登录（未设置密码时，出现设置密码弹窗，设置密码）
async function setKCPassApi(
  token: string, // 临时token,用于设置密码
  password: string
): Promise<APIResponse<any>> {
  try {
    await http.post("/tenant/setPassword", {
      token,
      password,
    })

    return new Ok(0)
  } catch (e: any) {
    return parseReqError(e, ERR_SET_KC_PASSWORD_API_REQ)
  }
}

// 获取公钥
async function getPublicKeyApi(): Promise<
  APIResponse<{ public_key: string; version: number }>
> {
  try {
    // 获取公钥
    const resp = await http.get("/v2/public-key", {
      withCredentials: false,
    })

    const publicKeyObj: { public_key: string; version: number } = resp.data
    return publicKeyObj
  } catch (e: any) {
    return parseReqError(e, ERR_GET_PUBLIC_KEY_API_REQ)
  }
}

// 获取壁纸列表
async function getWallpaperListApi(): Promise<APIResponse<WallpaperListRes>> {
  try {
    const resp = await http.get("/wallpaper/themes")
    return resp.data
  } catch (e: any) {
    return parseReqError(e, ERR_WALLPAPER_API_REQ)
  }
}

// 隐私相关接口=================================
// 获取图形验证码
async function getImageCaptcha(): Promise<APIResponse<ImgCodeRes>> {
  try {
    const resp = await http.post("/base/captcha")
    return resp.data
  } catch (e: any) {
    return parseReqError(e, -10664)
  }
}

// 验证图形验证码
async function captchaVerify(
  captchaId: string,
  captcha: string
): Promise<APIResponse<CaptchaVerifyRes>> {
  try {
    const resp = await http.post("/base/captchaVerify", {
      captchaId,
      captcha,
    })
    return resp.data
  } catch (e: any) {
    return parseReqError(e, -10665)
  }
}

// 发送短信验证码
async function sendVerificationCode(
  params: VerificationSendReq
): Promise<APIResponse<VerificationSendRes>> {
  try {
    const resp = await http.post("/base/verification/send", params)
    return resp.data
  } catch (e: any) {
    return parseReqError(e, -10666)
  }
}

// 查询最近登录设备
async function getLoginDevices(
  limit = 20
): Promise<APIResponse<LoginDeviceRes[]>> {
  try {
    const resp = await http.get("/tenant/privacy/login-devices", {
      params: { limit },
    })
    return resp.data
  } catch (e: any) {
    return parseReqError(e, -10826)
  }
}

// 设置或取消可信设备
async function updateTrustedDevice(
  deviceID: string,
  trusted: boolean,
  smsCode: string,
  smsToken: string
): Promise<APIResponse<TrustedDeviceRes>> {
  try {
    const resp = await http.put(`/tenant/privacy/trusted-devices/${deviceID}`, {
      trusted,
      smsCode,
      smsToken,
    })
    return resp.data
  } catch (e: any) {
    return parseReqError(e, -10829)
  }
}

// 查询隐私配置
async function getPrivacyConfig(): Promise<APIResponse<PrivacyConfigRes>> {
  try {
    const resp = await http.get("/tenant/privacy/config")
    return resp.data
  } catch (e: any) {
    return parseReqError(e, -10827)
  }
}

// 更新隐私配置
async function updatePrivacyConfig(
  params: PrivacyConfigUpdateReq
): Promise<APIResponse<PrivacyConfigRes>> {
  try {
    const resp = await http.patch("/tenant/privacy/config", params)
    return resp.data
  } catch (e: any) {
    return parseReqError(e, -10828)
  }
}

export const API = {
  getDeviceID,
  oldLogin,
  newLogin,
  deviceSecretLogin,
  createDeviceSecret,
  getDeviceStatus,
  // getWanIp,
  getImgCodeApi,
  getAgentStatus,
  getDeviceList,
  getDeviceListOld,
  getDeviceConnToken,
  deviceControl,
  setKCPassApi,
  getPublicKeyApi,
  getWallpaperListApi,
  getImageCaptcha,
  captchaVerify,
  sendVerificationCode,
  getLoginDevices,
  updateTrustedDevice,
  getPrivacyConfig,
  updatePrivacyConfig,
  getClientConfig,
  // [日志上传功能已注释] uploadLogZip,
}

/**
 * 获取客户端动态配置
 *
 * 对齐 android API.getClientConfig：
 * - 携带 If-None-Match 发起条件请求，validateStatus 放行 304；
 * - request.ts 响应拦截器对 /client-config 返回完整 response，这里解析出
 *   HTTP 状态、ETag 与业务码，交由上层（ClientConfigUseCase）判断 304/业务码。
 */
async function getClientConfig(params: {
  queryParameters: Record<string, string | number>
  ifNoneMatch?: string
}): Promise<APIResponse<ClientConfigResult>> {
  try {
    const headers: Record<string, string> = {}
    if (params.ifNoneMatch) {
      headers["If-None-Match"] = params.ifNoneMatch
    }
    const resp = await http.get("/client-config", {
      params: params.queryParameters,
      headers,
      // 放行 304，避免进入 error 分支
      validateStatus: (s) => s < 400,
    })
    const statusCode = resp.status
    const etag = resp.headers.etag as string | undefined
    // 304 响应体为空
    if (statusCode === 304) {
      return { statusCode, etag }
    }
    const body = resp.data as ClientConfigRawResp | undefined
    return {
      statusCode,
      etag,
      code: body?.code,
      msg: body?.msg,
      requestId: body?.requestId,
      data: body?.data ?? null,
    }
  } catch (e: any) {
    return parseReqError(e, ERR_GET_CLIENT_CONFIG_API_REQ)
  }
}

/* [日志上传功能已注释]
 * 上传日志 zip 到预签名 URL
 *
 * 对齐 android API.uploadLogZip：独立请求实例，PUT 裸字节，
 * Content-Type 置空（预签名未签 Content-Type，否则 KS3 校验失败）。
async function uploadLogZip(url: string, body: ArrayBuffer): Promise<APIResponse<void>> {
  try {
    await httpNoAuth.put(url, body, {
      headers: { "Content-Type": "" },
    })
  } catch (e: any) {
    return parseReqError(e, ERR_UPLOAD_LOG_API_REQ)
  }
}
*/

/**
 * 统一处理 API 错误
 * @param e 包含 HttpReqError (http 请求错误) 和 HttpAPIError (业务错误) 两种，将 http 请求错误转换成业务业务错误
 * @param code http 请求错误对应的错误码 (e 本身是业务错误则忽略)
 * @returns
 */
function parseReqError(e: any, code: number): HttpAPIError {
  if (e instanceof HttpAPIError) {
    return e
  }

  // 转换 "http 请求错误" 为 "业务错误"
  const err = e as HttpReqError
  return new HttpAPIError(code, `${err.path} 请求错误，status: ${err.status}`)
}
